import { MenuItem } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { BulkDeleteActionProps, useBulkDelete } from "./useBulkDelete";
import { BulkDeleteConfirmationModal } from "./BulkDeleteConfirmationModal";

/**
 * Component for bulk permanently deleting entries from the recycle bin
 * @data-endpoint recyclebin-recycle-bin-ds-delete
 */
export const BulkDeleteMenuItem = ({ entryIds, reloadMedia, apiUrl }: BulkDeleteActionProps) => {
    const { selectedCount, openConfirmation, processing, handleClick, handleDelete, closeConfirmation } = useBulkDelete(
        { entryIds, reloadMedia, apiUrl }
    );

    return (
        <>
            <MenuItem onClick={handleClick}>{translate("Delete")}</MenuItem>

            <BulkDeleteConfirmationModal
                open={openConfirmation}
                processing={processing}
                selectedCount={selectedCount}
                onClose={closeConfirmation}
                onConfirm={handleDelete}
            />
        </>
    );
};

export default BulkDeleteMenuItem;
